import React from "react";

const HighRiskFlag = props => (
  <svg width="14" height="19" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#707070"
        strokeLinecap="round"
        strokeWidth="2"
        d="M1.61 1.46V17.5"
      />
      <path
        fill="#CA6056"
        d="M2 1c1.55.6 3.06.9 4.54.9 2.2 0 2.23-.79 4.08-.9 1.23-.07 2.35-.02 3.36.17V9a7.55 7.55 0 0 0-3.36-.4C8.51 8.75 8 9.67 6.54 9.83A9.03 9.03 0 0 1 2 9V1z"
      />
    </g>
  </svg>
);

export default HighRiskFlag;
